import {
  Box,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../state/configureStore';
import {
  clearTaskActivity,
  fetchTaskActivityListBySubtaskId,
  fetchTaskActivityListByTaskId,
  TaskActivityState,
} from '../../../../state/taskActivity';
import useStyles from './taskActivityList.style';
import { DateTimeDisplay } from '../../../components/DateTimeDisplay';
import { Loading, DisplayHtmlContent } from '../../../components';

interface TaskActivityListProps {
  smTaskId: number;
  smSubtaskId?: number;
}

const TaskActivityList: React.FC<TaskActivityListProps> = (props) => {
  const { smTaskId, smSubtaskId } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { items: taskActivityList, loading: taskActivityIsLoading } = useSelector<
    AppState,
    TaskActivityState
  >((state) => state.taskActivity);

  useEffect(() => {
    if (smSubtaskId) {
      dispatch(fetchTaskActivityListBySubtaskId(smSubtaskId));
    } else {
      dispatch(fetchTaskActivityListByTaskId(smTaskId));
    }
    return function cleanUp() {
      // dispatch(clearTaskActivity());
    };
  }, [smTaskId, dispatch, smSubtaskId]);

  const getInitials = (fullName?: string | null) => {
    if (!fullName) {
      return 'A';
    }

    return fullName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((name) => name[0]?.toUpperCase())
      .join('');
  };

  return (
    <Loading isLoading={taskActivityIsLoading}>
      {taskActivityList.map((taskActivity) => {
        const authorName = taskActivity.user?.fullName || 'Unknown User';
        const subtaskLabel = taskActivity.smSubtask?.smSubtaskType?.name;

        return (
          <ExpansionPanel
            defaultExpanded={true}
            square
            className={classes.expansionPanel}
            key={
              taskActivity.id || `${authorName}-${taskActivity.createdAt || 'activity'}`
            }
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              className={classes.expansionPanelSummary}
            >
              <Box className={classes.summaryContent}>
                <Box className={classes.activityMarker}>{getInitials(authorName)}</Box>
                <Box className={classes.activityHeader}>
                  <Typography variant="body2" className={classes.activityTitle}>
                    {authorName}
                  </Typography>
                  <Box className={classes.activityMeta}>
                    {subtaskLabel ? (
                      <span
                        className={classes.subtaskBadge}
                      >{`Subtask ${subtaskLabel}`}</span>
                    ) : null}
                    <Typography component="span" className={classes.activityDate}>
                      <DateTimeDisplay value={taskActivity.createdAt} />
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.expansionPanelDetail}>
              <Box className={classes.activityBody}>
                <DisplayHtmlContent>{taskActivity.comment || ''}</DisplayHtmlContent>
              </Box>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      })}
    </Loading>
  );
};

export default TaskActivityList;
